import { useEffect, useRef, useState } from "react";
import { AddUpdateInsurerPayableAction, GetAppointmentInsurerAction, GetInsurerBillingClientAction, GetPayableAction } from "../../../redux/actions/PayoutAction";
import { getSnackbarSuccess, isLoadingAction, MandatoryStar } from "../../../Utils/helper";
import { useDispatch } from "react-redux";
import { getNetworkMenuId } from "../../../Utils/types";


export const UpdateInvoice = ({ searchFilter, invoice, setInvoice, 
  payableData,
  setPayabelData,
  rowData,
  firstPageData,
  insBillingPage,
   }) => {
  const [data, setData] = useState({
    invoiceNo:"",
    invoiceDate:""
  });
  const ref = useRef();
  const dispatch = useDispatch();
  console.log("firstPageData",firstPageData)
  useEffect(() => {
    if (invoice?.rowData?.requestStatus === "Paid") {
      setData({
        invoiceNo:invoice?.rowData?.invoiceNo,
        invoiceDate:invoice?.rowData?.invoiceDate,
      });
    }
  }, [invoice]);

  const handleClose = () => {
    setInvoice({
      isOpen: false,
      rowData: null,
    });
  };

  const handleSubmit = async(event)=>{
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()){
      if ( rowData?.detailType === "InsurerBillingQC"){
        let res;
        let clId = payableData.map((ele) => {
          return { clientId: ele?.clientId };
        });
        let apiId = payableData?.map((ele) => {
          return { appointmentId: ele?.appointmentId };
        });
        
        if (insBillingPage === "firstPage") {
          res = await dispatch(
            AddUpdateInsurerPayableAction({
              providerIds: null,
              year: invoice?.rowData?.year,
              month: invoice?.rowData?.month,
              RequestId: invoice?.rowData?.requestID,
              qcType: "PROVIDERWISE",
              BusinessType: invoice?.rowData?.buType,
              clientIds:[{ clientId:invoice?.rowData?.clientId}],
              invoiceNumber:data?.invoiceNo,
              invoiceDate:data?.invoiceDate
            })
          );
          if (res) {
            await dispatch(
              GetInsurerBillingClientAction({
                ...searchFilter,
                sessionId: firstPageData?.sessionID,
                ticketId: firstPageData?.requestID,
                providerId:null
              })
            );
          }
        } else if (insBillingPage === "secondPage") {
          res = await dispatch(
            AddUpdateInsurerPayableAction({
              providerIds: null,
              appointmentIds: apiId,
              year: payableData[0]?.year,
              month: payableData[0]?.month,
              requestId: payableData[0]?.requestID,
              qcType: "APPOINTMENTWISE",
              BusinessType: payableData[0]?.buType,
              clientIds:clId,
              invoiceNumber:data?.invoiceNo,
              invoiceDate:data?.invoiceDate
            })
          );
          if (res) {
            dispatch(
              GetAppointmentInsurerAction({
                ...searchFilter,
                sessionId: rowData?.sessionId,
                ticketId: rowData?.requestID,
                providerId: rowData?.providerId,
                clientId:rowData?.clientId
              })
            );
          }
        }
    
        if (res?.data?.status === true) {
          ref.current.click();
          getSnackbarSuccess("success", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
          setPayabelData([]);
        } else {
          getSnackbarSuccess("error", res?.data?.message, dispatch);
          isLoadingAction(false, dispatch);
        }
      }


    }
  }
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
         Invoice Detail
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          ref={ref}
          onClick={handleClose}
        ></button>
      </div>
      <form className="form-admin" onSubmit={handleSubmit} noValidate>
        <div className="modal-body addusermodalbox">
          <div className="row">
          <div className="col-lg-6 col-md-6">
              <label htmlFor="User Type" className="col-form-label">
                Invoice No.
                <MandatoryStar />
              </label>
              <input
                name="utrNumber"
                type="text"
                placeholder="Invoice No."
                className="form-control form-select-admin inputbgavanish"
                value={data?.invoiceNo}
                required
                onChange={(e)=>{
                  setData({...data,invoiceNo:e.target.value})
                }}
                onKeyPress={(e)=>{
                  if(e.key === " "){
                    e.preventDefault()
                  }
                }}
              />
            </div>
            <div className="col-lg-6 col-md-6">
              <label htmlFor="User Type" className="col-form-label">
                Invoice Date
                <MandatoryStar />
              </label>
              <input
                name="paymentDate"
                type="date"
                placeholder="Centre SKU Name"
                required
                className="form-control form-select-admin inputbgavanish"
                value={
                  data?.invoiceDate
                    ? data?.invoiceDate.split("T")[0]
                    : null
                }
                onChange={(e)=>{
                  setData({...data,invoiceDate:e.target.value})
                }}
              />
            </div>
           
          </div>
            <div className="modal-footer modal-footer-admin justify-content-between accept-reject-btns bottom-0 d-flex mt-4">
              <div>
              {invoice?.rowData?.requestStatus !== "Paid" && (
                <button type="submit" disabled={getNetworkMenuId()?.canEdit === false} className="savedetails ">
                  <img
                    
                    src="./../images/save-icon-white.png"
                    alt=""
                  />
                  Save
                </button>
              )}
              </div>
            </div>
        </div>
      </form>
      
    </>
  );
};
